import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=aa9685e4"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports